'use client';

import Link from 'next/link';
import { useState } from 'react';

import { requestPasswordReset } from '@/app/actions/password-reset';
import { SubmitButton } from '@/app/components/shared/SubmitButton';

export default function ForgotPasswordForm() {
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(formData: FormData) {
    setError(null);
    try {
      await requestPasswordReset(formData);
      setSubmitted(true);
    } catch {
      setError('An unexpected error occurred. Please try again.');
    }
  }

  if (submitted) {
    return (
      <div className="flex flex-col gap-4 bg-white px-6 py-6 sm:px-12">
        <p className="text-[13px] leading-[20px] text-black">
          If your email is registered, you&apos;ll receive a password reset link
          shortly. Check your inbox (and spam folder).
        </p>
        <p className="text-center text-[11px]">
          <Link
            href="/login"
            className="text-sourced-black hover:text-sourced-pink transition-colors"
          >
            Back to sign in
          </Link>
        </p>
      </div>
    );
  }

  return (
    <>
      {error && (
        <div className="flex justify-center w-full">
          <div
            className="bg-red-100 border border-red-400 text-red-700 px-3 py-2 mt-2 rounded-md mb-0 block w-80 appearance-none"
            role="alert"
          >
            <span className="block sm:inline text-sm">{error}</span>
          </div>
        </div>
      )}
      <form
        action={onSubmit}
        className="flex flex-col gap-4 bg-white px-6 py-6 sm:px-12"
      >
        <div>
          <label
            htmlFor="email"
            className="block text-[11px] leading-[12px] text-black uppercase tracking-[0.33px]"
          >
            Email Address
          </label>
          <input
            id="email"
            name="email"
            type="email"
            placeholder="user@acme.com"
            autoComplete="email"
            required
            className="mt-1 w-full sb-field placeholder-black/50 bg-transparent"
          />
        </div>
        <SubmitButton defaultText="Send reset link" pendingText="Sending..." />
        <p className="text-center text-[11px]">
          <Link
            href="/login"
            className="text-sourced-black hover:text-sourced-pink transition-colors"
          >
            Back to sign in
          </Link>
        </p>
      </form>
    </>
  );
}
